export default "/images/favorites_empty_state.webp"